import { Trans } from "@lingui/macro"
import { Button, ButtonsContainer, Icon, Modal, ModalBody } from "@silversea-ssc/ui-components-react"
import React from "react"
import { ReactElement } from "react"
import styles from "./ErrorBox.module.scss"

type ButtonProps = {
    onClick: () => void
    label: string | ReactElement
}

interface ErrorBoxProps {
    title?: string | ReactElement
    message?: string | ReactElement
    button?: ButtonProps
    hideIcon?: boolean
}

const ErrorBox: React.FC<React.PropsWithChildren<ErrorBoxProps>> = ({
    title = <Trans id="error-box-title">It looks like there&apos;s a problem with the system</Trans>,
    message,
    button,
    hideIcon = false,
}) => {
    return (
        <Modal modal={{ isOpen: true, onRequestClose: undefined }} size="small" dataContentName="error_modal">
            <ModalBody variant="full" className={styles.modalBodyWrapper}>
                <div className={styles.errorIconContainer}>
                    {!hideIcon && (
                        <React.Fragment>
                            <Icon name="alert" size="2x" padding="inline" />{" "}
                            <Trans>Error in processing your request</Trans>
                        </React.Fragment>
                    )}
                </div>
                <div className={styles.modalContent}>
                    {title && <div className={styles.title}>{title}</div>}
                    <div className={styles.body}>{message}</div>

                    {button && (
                        <div className={styles.buttonsContainer}>
                            <ButtonsContainer mobileFullSize>
                                <Button
                                    size="regular"
                                    variant="primary"
                                    onClick={button.onClick}
                                    dataContentPiece="error_button"
                                >
                                    {button.label}
                                </Button>
                            </ButtonsContainer>
                        </div>
                    )}
                </div>
            </ModalBody>
            {/* <ModalFooter className={styles.modalFooter}>

            </ModalFooter> */}
        </Modal>
    )
}

export default ErrorBox
